import { BaseClient } from 'src/common-services/clients/base-client'
import { ParcelTileProperties } from 'src/types/tiles'

export class ParcelsClient extends BaseClient {
  getMCodeByLatLng(request: { lat: number; lng: number }): Promise<{ mCode: ParcelTileProperties['mCode'] }> {
    return this.call<{ mCode: ParcelTileProperties['mCode'] }>('/vendors/properties/mcode', 'POST', { data: request })
  }
}
